import React from "react";
import PolicyLayout from "./PolicyLayout";

const sections = [
  <>At <b>Alpaago</b>, we strive to ensure your complete satisfaction. If you receive a defective or incorrect product, you may request a return within <b>7 business days</b> of receipt.</>,
  <>Returned products must be unused, in original packaging, and accompanied by proof of purchase.</>,
  <>Once inspected and approved, returns will be processed and confirmed via email or SMS.</>,
  <>For return assistance, contact <b>contact@alpaago.com</b> or call <b>+91 73974 60454</b>.</>,
];

export default function ReturnPolicy() {
  return <PolicyLayout title="Return Policy" sections={sections} />;
}
